<template>
  <el-select
    v-model="brandId"
    filterable
    remote
    clearable
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading">
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.blandName"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import Appraise from '@/service/appraise'
export default {
  name: 'BrandRemoteSelect',
  props: {
    value: { required: true },
    placeholder: { type: String, default: '请输入品牌名称' }
  },
  data() {
    return { loading: false, options: [], config: { pageNum: 1, pageSize: 50 }}
  },
  computed: {
    brandId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    remoteMethod(blandName) {
      if (this.loading) {
        return
      }
      if (blandName) {
        this.loading = true
        Appraise.getappraisalblands({ pageNum: 1, pageSize: 50, blandName, status: 1 })
          .then(res => {
            this.loading = false
            const { result, message, records } = res.data
            if ([0, 13].includes(result)) {
              this.options = records
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      }
    }
  }
}
</script>
